import { render, staticRenderFns } from "./saveQuestionTag.vue?vue&type=template&id=06a4169d&"
import script from "./saveQuestionTag.vue?vue&type=script&lang=js&"
export * from "./saveQuestionTag.vue?vue&type=script&lang=js&"
import style0 from "./saveQuestionTag.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports